import { useEffect, useState, useContext, useRef, forwardRef, useImperativeHandle } from 'react'

import M2niCascadedList from '../selectionFolder/m2ni_cascaded_list/index'
import FileItemEdit from '../selectionFolder/fileItem/fileItemEdit/index'
import SelectionFolder from '../selectionFolder/folder'
import { Modal, Button, message, Radio } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import myContext from '../../utils/context'
import * as apis from '../../api/networkDisk'
import { StorageModule } from '../../modules/storage'
import JionThemes from './jionThemes'
import Drag from './drag'
import { createHashHistory } from "history";
import useStore from '../../store/useStore'
import style from './index.module.scss'
import { getUserList } from '../../api/user'

interface Props {
    title?: any
    visible: any
    //type=clearCheck 清除私有选中状态
    onClose: (type?: any) => void;
    itemInfo?: any
    onRefresh?: () => void;
    history?: any;
    isFooterButton?: any;
    //是否是讨论中的主题
    isJion?: any
    //是否是私有的
    subjeckPrivate?: any
    ref?: any
}
interface State {
    folderList: any[]
    dirList: any[]
    tree: any[];
    list: any[];
    delVisible: boolean;
    delInfo: any;
    moveTimer: any;
    isMove: boolean;
    moveNode: any;
    moveLeft: number;
    moveTop: number;
    offsetX: number;
    offsetY: number;
    startNode: any;
    moveIndex: number;
    startIndex: number;
    saveLoading: boolean;
    type: string;
    backParentId: any;

}


export default forwardRef((props: Props, ref: any) => {
    const [state, setState] = useState<State>({
        folderList: [],
        dirList: [],
        tree: [],
        list: [],
        delVisible: false,
        delInfo: {},
        moveTimer: null,
        isMove: false,
        moveNode: {},
        moveLeft: 0,
        moveTop: 0,
        offsetX: 0,
        offsetY: 0,
        startNode: {},
        moveIndex: -1,
        startIndex: -1,
        saveLoading: false,
        type: '',
        backParentId: -1,

    });
    const user: any = StorageModule.getUser().user;

    const [checkItemData, setCheckItemData] = useState<any>();
    const [checkListData, setCheckListData] = useState<any>();
    let memoId = useRef<string | null>();

    const [loadings, setLoadings] = useState<boolean[]>([]);
    const [isdbClick, setIsdbClick] = useState<boolean>(false);
    const [ModalClose, setModalClose] = useState<boolean>(false);

    const [radioVal, setRadioVal] = useState<any>('a');
    const [userList, setUserList] = useState<any>([]);
    const [pageIndex, setPageIndex] = useState<any>(1);
    const [total, setTotal] = useState<any>();

    const divRef = useRef(null);
    const [isAtBottom, setIsAtBottom] = useState(false);
    const [userId, setUserId] = useState<any>('');

    const ContextProps = {
        checkItemData,
        setCheckItemData,
        checkListData,
        setCheckListData,
        isdbClick,
        ModalClose,
        setModalClose
    }
    const reviceProps = useContext(myContext)
    const { store, dispatch } = useStore();

    let history = createHashHistory();

    useImperativeHandle(ref, () => ({
        getListHandle: () => {
            getList()
        }
    }));
    useEffect(() => {
        console.log('StorageModule.getUser().user', user, StorageModule.getUser().user)
        if (props.visible) {
            setRadioVal('a')
            getList()
        } else {
            setCheckItemData('')
            getList()
        }
        setIsdbClick(props.isFooterButton)
    }, [props.visible])
    useEffect(() => {
        if (!props.isJion) {
            getList()
            setRadioVal('a')
        } else {
            setRadioVal(null)
        }
    }, [props.isJion])

    useEffect(() => {
        if (radioVal == 'b') {
            getUserListFuc({ index: pageIndex, })
        } else {
            setPageIndex(1)
            setUserId(null)
            getList()
            setUserList([])

        }
    }, [radioVal])
    useEffect(() => {
        if (ContextProps.ModalClose) {
            props.onClose()
            setModalClose(false)
        }
    }, [ContextProps])
    useEffect(() => {
        console.log('isAtBottom', isAtBottom, total, userList)
        if (isAtBottom && userList.length < total && total > 0) {
            console.log('ll')
            // setTimeout(() => {
            getUserListFuc({ index: pageIndex, })
            // }, 200);
        }
    }, [isAtBottom]);

    const checkScrollPosition = () => {
        const divElement: any = divRef.current;
        if (divElement) {
            const isScrolledToBottom =
                divElement.scrollTop + divElement.clientHeight === divElement.scrollHeight;
            setIsAtBottom(isScrolledToBottom);
        }
    };

    useEffect(() => {
        const divElement: any = divRef.current;
        console.log('divElement', divElement)
        if (divElement) {

            divElement.addEventListener('scroll', checkScrollPosition);
        }
        return () => {
            if (divElement) {
                divElement.removeEventListener('scroll', checkScrollPosition);
            }
        };
    }, [divRef.current]);
    /**
     * 获取列表
     */
    const getList = async (params?: any): Promise<void> => {
        let _params = (params) ? params : { userId: user?.id.toString() }
        console.log('getList')
        try {
            let res: any = await apis.excellingTopic({ ..._params, permissionType: (user?.id.toString() != _params?.userId) ? 'OVERT' : "" })
            if (res.ok) {
                state.dirList = res.data
                setState({ ...state })
            }
        } catch (err) {
            console.log(err)
        }
    }
    const getUserListFuc = async (page?: any): Promise<void> => {
        try {

            let res: any = await getUserList({ $skip: (page.index - 1) * 20, $limit: 20 })
            if (res.ok) {
                setUserList(userList.concat(res.data.list))
                setTotal(res.data.total)
                setPageIndex(pageIndex + 1)
            }
        } catch (err) {
            console.log(err)
        }
    }
    /**
     * @name 提交选中
     */
    const submit = async () => {
        try {
            console.log(memoId, checkItemData)
            let params: any = {

                $operate$: "save",
                memoId: memoId[1],
                subject: reviceProps.subject,
                permissionType: (!props.subjeckPrivate) ? 'OVERT' : 'PRIVATE'
            }
            if (checkItemData) {
                params.parentId = checkItemData
            }
            let res: any = await apis.putExcellingTopic(memoId[0], params)
            if (res.ok) {
                message.success('创建主题成功')
                dispatch({
                    type: 'SET_SUBJECTINFO',
                    data: { ...store.subjectInfo, subjectId: memoId[0], data: store.subjectInfo.initData }
                });
                setTimeout(() => {
                    window.location.hash = '#/view'
                }, 500);
                props.onClose('clearCheck')
                reviceProps.setAddThemeVisible(false)
                reviceProps.setSubject('')
                // StorageModule.set('subjectInfo', { ...store.subjectInfo, subjectId: memoId[0] })
                // history.push({pathname: '/memo', state: {id: memoId[0]}});
            }
        } catch (e) {
            setLoadings([false])
        }

    }
    /**
     * @name 请求根新建主题/便签主键
     */
    const getId = async () => {

        try {

            let res: any = await apis.sequenceSerial()
            if (res.ok) {
                console.log(res)
                memoId = res.data
                submit()

            }
        } catch (e) {
            setLoadings([false])
        }

    }
    /**
         * @name 取消
         */
    const cancel = () => {
        //清除所有状态
        state.dirList = []
        setState({ ...state })
        setCheckItemData(null)
        setCheckListData(null)
        setLoadings([false])
        props.onClose();

    }

    return (
        <>
            <Modal
                onCancel={() => {
                    props.onClose()
                }}
                title={<div data-flex='main:justify cross:center'>
                    <Radio.Group value={radioVal} style={{ marginTop: 16 }} onChange={(e) => {
                        state.dirList = []
                        setState({ ...state })
                        setTimeout(() => {
                            setRadioVal(e.target.value)
                        }, 200);
                    }}>
                        <Radio.Button value="a">主题列表</Radio.Button>
                        <Radio.Button value="b">用户列表</Radio.Button>
                    </Radio.Group>

                    <>{props.title}</></div>}
                width={'70%'}
                footer={null}
                open={props.visible}>
                <div style={{ height: '55vh', overflow: 'hidden' }}>
                    {props.isJion ? <JionThemes onClose={() => { props.onClose() }} /> :

                        <><div data-flex={radioVal == 'b' ? 'main:left cross:center' : 'null'}>{radioVal == 'b' &&
                            <div data-flex='main:left' className={`selectionFolder_list`} style={{ flex: '0 0 250px', width: '250px' }} id='box'>
                                <div className={style.list_column} ref={divRef}>
                                    {userList.map((i: any) => (
                                        <div data-flex='main:justify cross:center' className={`${style.list_column_item} ${(userId == i.id) ? style.list_column_item_active : ''}`}>
                                            <div className={style.title + ' sl-ellipsis'} onClick={(e) => {
                                                state.dirList = []
                                                setState({ ...state })
                                                setUserId(i.id)
                                                getList({ userId: i.id })
                                            }}><span>{i.username}</span></div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }
                            <div style={{ overflow: 'auto', width: (radioVal == 'b') ? 'calc(100% - 240px)' : '100%', flex: '0 0 calc(100% - 240px)' }}>
                                <myContext.Provider value={ContextProps}>

                                    {/* initList={[{
                            coverId: null, fileCount: null, id: 3109401722863616, name: "1", orderNum: 1, parentId: 0, share: false, timeLower: null, timeUpper: null, userId: 3103953535434752
                        },
                        {
                            coverId: null, fileCount: null, id: 3109401722863617, name: "22", orderNum: 1, parentId: 0, share: false, timeLower: null, timeUpper: null, userId: 3103953535434752
                        }]}  
                       
                        */}

                                    <M2niCascadedList initList={state.dirList}
                                        getList={getList}
                                        params={{ type: 'add', data: { userId: userId } }}
                                        fileItemEdit={(
                                            data: any,
                                            index: number,
                                            colIndex: number,
                                            onClickEdit: any,
                                            setMoveNode: any,
                                            setMovePlace: any,
                                            list: any,
                                            setInitNode: any,
                                            onGetList: any) => (<FileItemEdit
                                                data={data}
                                                index={index}
                                                colIndex={colIndex}
                                                onClickEdit={onClickEdit}
                                                onGetList={onGetList}
                                                setInitNode={setInitNode}
                                                setMoveNode={setMoveNode}
                                                setMovePlace={setMovePlace}
                                                list={list}
                                            />)}></M2niCascadedList>
                                </myContext.Provider>
                            </div>
                            {props.isFooterButton && <div data-flex='main:right'>
                                <Button className='btn mr-10' onClick={() => {
                                    cancel()
                                }}>上一步</Button>
                                <Button className='btn ' type='primary' loading={loadings[0]} onClick={() => {
                                    getId()
                                }} icon={<CheckOutlined />} >确定创建</Button>

                            </div>
                            }  </div></>}
                </div>
            </Modal>

        </>
    )
})

